import type { SVGProps } from "react";

type RainCloudsProps = SVGProps<SVGSVGElement> & {
  /** Icon size in px (width and height), matching the lucide-react API. */
  size?: number | string;
};

/**
 * Two clouds with rain — a front cloud with a second cloud peeking behind it
 * and rain streaks below. Outline only (no fill/color), following the elg5
 * lucide-style icon conventions: 24x24 viewBox, currentColor stroke, width 2,
 * round caps/joins.
 *
 * The front cloud reuses lucide's `Cloud` outline (flattened a little via the
 * matrix transform to leave room for rain); `vectorEffect="non-scaling-stroke"`
 * keeps its stroke width uniform with the hand-drawn parts despite the scale.
 */
export function RainClouds({ size = 24, ...props }: RainCloudsProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* front cloud */}
      <path
        d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"
        transform="matrix(0.9 0 0 0.7 0.7 1.7)"
        vectorEffect="non-scaling-stroke"
      />
      {/* rain */}
      <path d="M6 17l-1.2 2.8" />
      <path d="M9.5 17.6l-1.2 2.8" />
      <path d="M13 17l-1.2 2.8" />
      <path d="M16.5 17.6l-1.2 2.8" />
    </svg>
  );
}
